import React, { useState } from 'react';
import { submitStyleSmall } from '../../auth/styles';

import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useForm } from '../hooks';
import { useDispatch, useSelector } from 'react-redux';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import 'sweetalert2/dist/sweetalert2.css';
import {
  getAmtItems,
  getInsightSettings,
  setMeds,
  updateInsightSettings,
} from '../../store/ai2';

const formData = [];

function AddMedication(data) {
  const navigate = useNavigate();

  const { formState, onInputChange } = useForm(formData);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentSettings] = useState(data.currentSettings);
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  let { insightSettings, meds } = useSelector((state) => state.insightSettings);
  const dispatch = useDispatch();

  async function handleSubmit(e) {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      return;
    } else {
      e.preventDefault();
      setValidated(true);
      await getData();
    }
  }

  async function getData() {
    setLoading(true);
    await dispatch(
      getInsightSettings(data.accessToken, selectedTenancy.tenancy_id),
    );
    await dispatch(getAmtItems(formState.searchText));
    setLoading(false);
  }

  async function handleAdd(e) {
    dispatch(
      updateInsightSettings(selectedTenancy, data.accessToken, [e]),
      [],
    ).then(() => {
      Swal.fire({
        icon: 'success',
        text: 'Medication Added.',
        showConfirmButton: true,
        willClose: () => {
          getData();
        },
      });
    });
  }

  let medsList = meds.map((med, index) => {
    function getButton() {
      if (
        insightSettings.medication_settings.findIndex(
          (x) => x.mpp_id === med.mpp_id,
        ) > -1 ||
        currentSettings.findIndex((x) => x.mpp_id === med.mpp_id) > -1
      ) {
        return (
          <div className={'col-2 offset-1'}>
            {' '}
            <button
              style={{
                margin: '0px 3px 0 auto',
                padding: '6px 6px',
                border: '1px solid #634a75',
                borderRadius: '6px',
                background: 'transparent',
                minWidth: '60px',
                width: '5%',
                fontSize: '13px',
                color: '#634a75',
              }}
            >
              Added
            </button>{' '}
          </div>
        );
      } else {
        return (
          <div className={'col-2  offset-1'}>
            {' '}
            <button
              style={submitStyleSmall}
              onClick={() =>
                handleAdd({
                  mpp_id: med.mpp_id,
                  settings: {
                    dosageFrequency: 'per day',
                    dosageQty: 0,
                    changeInsight: 'None',
                  },
                })
              }
            >
              Add
            </button>{' '}
          </div>
        );
      }
    }

    return (
      <div className={'col-12'}>
        <div className={' mb-3'}>
          <div className={'row'}>
            {getButton()}
            <p className={'col-9'}>{med.medicinal_product_pack}</p>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        onReset={(handleReset) => {
          setValidated(false);
          dispatch(setMeds({ meds: [] }));
        }}
      >
        <div className="flexVertWrap text-lg-start pt-3">
          <b>Search for medication</b>
          <br />
        </div>

        <div className="flexVertWrap text-lg-start">
          <div className={'row'}>
            <Form.Group as={Col} md="8">
              <Form.Control
                required
                placeholder="Medication name"
                type="text"
                name="searchText"
                id="search-text"
                autoComplete="off"
                onChange={onInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please provide a medication name
              </Form.Control.Feedback>
            </Form.Group>

            <div className={'col col-md-4'}>
              <button style={submitStyleSmall} type="submit">
                Search
              </button>

              <button
                style={{
                  margin: '0px 3px 0 auto',
                  padding: '6px 6px',
                  border: '1px solid #634a75',
                  borderRadius: '6px',
                  background: 'transparent',
                  minWidth: '60px',
                  width: '5%',
                  fontSize: '13px',
                  color: '#634a75',
                }}
                type="reset"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </Form>
      {loading && <div className={'text-center'}>Getting medications..</div>}

      {!loading && (
        <div
          className={'row'}
          style={{
            overflowX: 'hidden',
            maxHeight: '60vh',
            overflowY: 'scroll',
          }}
        >
          {meds.length > 0 && medsList}
        </div>
      )}
    </div>
  );
}

export default AddMedication;
